/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, replacePXinStringWithEM, mediaQuery } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// STRUCTURE : HEADER : STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
	header: {
		background: theme.color.supporting.light.swatch,
		borderBottom: replacePXinStringWithEM(`1px solid #ddd`),
		// boxShadow: replacePXinStringWithEM(`0 1px 0 0 ${theme.boxShadow.bar}`),
		color: theme.color.dark.dark.contrast,
		height: pxToEm(80),
		width: '100%',
		padding: replacePXinStringWithEM(`0px ${theme.spacing.sides}`),
		position: 'relative',
		zIndex: '2',

        // layout
		display: 'flex',
		alignContent: 'center',
		alignItems: 'center',
		justifyContent: 'flex-start',

		// animations
		opacity: '0',
		animationName: 'fadeInDown',
		animationDelay: '.1s',
		animationDuration: '.2s',
		animationFillMode: 'forwards',


		// ----- GROUPS ----- //
		'& > .group': {
			// +++++ logo +++++ //
			'&.name-logo': {
				flex: '0',
				paddingRight: pxToEm(20)
			},
			// +++++ navs +++++ //
			'&.name-navs': {
				flex: '1',
				display: 'flex',
				justifyContent: 'space-between',
				// topnav
				'& .name-sections': {
					flex: '1',
					display: 'flex',
					'& .logo.name-insticator-icon': {
						marginRight: pxToEm(30)
					}
				},
				// account
				'& .name-account':{
					flex: '0',
					display: 'inline-flex',
					alignItems: 'center',
			        fontSize: pxToEm(15),
			        fontWeight: 600,
			        position: 'relative',
			        transition: 'all .1s ease-out 1s',
			        '& .greeting':{
			            color: theme.color.supporting.dark.swatch
			        },
			        '& .username':{
			            paddingLeft: pxToEm(8),
			            color: theme.color.primary.medium.swatch,
			            cursor: 'pointer',
			            whiteSpace: 'nowrap',
			            '& .icon': {
			                position: 'relative',
			                top: pxToEm(-2)
			            }
			        },
					'& .link.name-logout':{
						color: theme.color.supporting.dark.swatch,
						fontWeight: 600,
						marginLeft: pxToEm(25),
					},
					// hide menus on large displays
					'& .menu': {
						'& .menugroup': {
							'&.name-pageitems': { display: 'none' },
							'&.name-logoutitems': { display: 'none' },
							'& .menutitle': { display: 'none' }
						}
					}
				}
			}
		}
	},

	// ((((((((((((((( MEDIA QUERIES ))))))))))))))) //
	[mediaQuery.thinnest]: { 
		header: {
			justifyContent: 'space-between',
			'& > .group': {
				// +++++ navs +++++ //
				'&.name-navs': {
					flex: '0',
					// topnav
					'& .name-sections': {
						display: 'none'
					},
					// account
					'& .name-account':{
						'& .menu': {
							'& .menuitems': {
								left: 'auto',
								right: pxToEm(-112),
								'& .arrow': {
									alignSelf: 'flex-end',
									marginRight: pxToEm(10)
								}
							},
							'& .menugroup': {
								'&.name-pageitems': { display: 'block' },
								'&.name-logoutitems': { display: 'block' },
								'& .menutitle': { display: 'block' }
							}
						},
						'& .link.name-logout':{
							display: 'none'
						}
					}
				}
			}
		}
	}
});